import { State } from 'src/types'
import { hamidashiOfNormal } from '../hamidashi/normal'
import { middleFingerLeft, middleFingerRight } from 'src/features/yellStory/drawer/glove/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/yellStory/drawer/glove/back/ringFinger'
import { thumbEmbroideryDrawer } from 'src/features/yellStory/drawer/common/back/useCanvasEmbroideries'
import { indexFingerLeft, indexFingerRight } from '../indexFinger'
import { littleFingerLeft, littleFingerRight } from '../littleFinger'
import { thumbAndListBelt, thumbOut } from '../thumbAndListBelt'
import { listBelt } from '../listBelt'
import { indexFingerPad } from '../fingerCoverOrPad/indexFingerPad'
import { fingerCrotch } from '../fingerCrotch'
import { catchFace2 } from '../catchFace2'
import { edgeOfBeltBackStyle } from '../edge/edgeOfBeltBackstyle'
import { edgeOfWrist } from '../edge/edgeOfWrist'
import { indexFingerCover } from '../fingerCoverOrPad/indexFingerCover'

// 通常ベルトモデル
export const yellStoryBeltBackStyleDrawer = (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): void => {
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isIndexFingerCover = ['indexCover'].includes(state.fingerGuardType?.value)

  // 親指指袋_手口ベルト(下地)
  thumbAndListBelt(ctx, state.thumbWeb?.color, state.stitch.color)
  // 親指＿外
  thumbOut(ctx, state.thumbOut?.color)
  // 親指への刺繍
  thumbEmbroideryDrawer(ctx, state.embroideries)
  //
  if (['normal', 'unselected', undefined].includes(state.beltType?.value)) {
    listBelt(ctx, state.listBelt?.color, state.stitch.color)
  }

  // 人差し指＿右
  indexFingerRight(ctx, state, needCatchFaceWrap)
  // 人差し指＿左
  indexFingerLeft(ctx, state.leatherIntegratedIndex?.value === 'none' ? state.indexMiddle?.color : state.indexWeb?.color)
  // 中指＿右
  middleFingerRight(ctx, state.middleIndex?.color)
  // 中指＿左
  middleFingerLeft(ctx, state.leatherIntegratedMiddle?.value === 'none' ? state.middleRing?.color : state.middleIndex?.color)
  // 薬指＿右
  ringFingerRight(ctx, state.ringMiddle?.color)
  // 薬指＿左
  ringFingerLeft(ctx, state.leatherIntegratedRing?.value === 'none' ? state.ringLittle?.color : state.ringMiddle?.color)

  // 小指＿右
  littleFingerRight(ctx, state.littleRing?.color)
  // 小指＿左
  littleFingerLeft(ctx, state.littleOut?.color)

  // ハミダシ
  hamidashiOfNormal(
    ctx,
    state.hamidashi.color,
    state?.leatherIntegratedIndex,
    state?.leatherIntegratedMiddle,
    state?.leatherIntegratedRing,
    state?.indexWeb?.color,
    state?.middleIndex?.color,
    state?.ringMiddle?.color
  )
  // 捕球面 / ウェブ下折り返し
  catchFace2(ctx, state.catchFace?.color, state.stitch?.color, needCatchFaceWrap)
  // ヘリ革
  edgeOfBeltBackStyle(ctx, state.edge?.color, state.stitch?.color)
  edgeOfWrist(ctx, state.edge?.color, state.stitch?.color)

  // 指当て(人指し指)
  isIndexFingerPad && indexFingerPad(ctx, state.indexCover?.color, state.stitch?.color)
  // 指股
  fingerCrotch(ctx, state.catchFace?.color, state.hamidashi?.color, state.baseModel?.isFingerCrotch)
  // 指カバー(人差し指)
  isIndexFingerCover && indexFingerCover(ctx, state.indexCover?.color, state.stitch?.color)
}
